import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-brochure-dialog',
  templateUrl: './brochure-dialog.component.html',
  styleUrls: ['./brochure-dialog.component.scss']
})
export class BrochureDialogComponent implements OnInit {
    @ViewChild('pdfViewerAutoLoad') pdfViewerAutoLoad;

    isMobile: boolean = window.innerWidth <= 768;
    isIOS: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobile = window.innerWidth <= 768;
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<BrochureDialogComponent>) {
      // Detect iOS devices
      this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
    }

    ngOnInit() {
        // will log the entire data object
        console.log(this.data);
        
        // Fix for iOS viewport height issues
        if (this.isIOS) {
          this.fixIOSViewport();
        }
      }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public onLoad(event: any): void {
    if (this.data.pageIndex)
    {
        this.pdfViewerAutoLoad.page = this.data.pageIndex;
    }
  }

  private fixIOSViewport(): void {
    // Force iOS to recalculate viewport height
    setTimeout(() => {
      window.scrollTo(0, 1);
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    }, 100);
  }
}
